import React from 'react';
import './Home.css';
import Header from '../components/Header';

const Home = () => {
  return (
    <div>
      
      <div className="LeftPage">
        <Header />
      </div>
     </div>
  );
};

export default Home;
